import {Component, Inject, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {NotifierService} from 'angular-notifier';
import {ApiService} from 'src/app/services/api.service';
import {ErrorHelper} from 'src/app/common/ErrorHelper';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';

export interface DisId {
  disId: string;
}

@Component({
  selector: 'app-manage-image-set',
  templateUrl: './manage-image-set.component.html',
  styleUrls: ['./manage-image-set.component.css']
})
export class ManageImageSetComponent implements OnInit {

  displayedColumns: string[] = ['disId', 'copy', 'rename', 'delete'];
  dataSource: MatTableDataSource<DisId>;

  constructor(private apiService: ApiService,
              private notifierService: NotifierService,
              public dialog: MatDialog) {
    this.loadDisIdListAsync();
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
  }

  async loadDisIdListAsync(): Promise<any> {
    try {
      await this.loadDisIdList();
    } catch (error) {
      console.log(error);
    }
  }

  loadDisIdList(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return this.apiService.getAllDeploymentSets().toPromise().then(
        (data) => {
          const disIdList = [];
          for (const disId of data) {
            disIdList.push({disId});
          }
          this.dataSource = new MatTableDataSource(disIdList);
          console.log('Fetched the dis id list');
          resolve(true);
        },
        (error) => {
          const errorMessage = ErrorHelper.disectError('load dis idss', error);
          this.notifierService.notify('error', errorMessage);
          resolve(false);
        });
    });
  }


  copyDis(disId: string): void {
    console.log('copy ' + disId);
    const dialogRef = this.dialog.open(DialogCopyImageSetComponent, {
      data: {
        disId
      },
      width: '1000px',
      maxWidth: '100vw',
    });
    dialogRef.componentInstance.targetDisId = disId;
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result) {
        console.log(`Dialog targetDisId: ${dialogRef.componentInstance.targetDisId}`);
        this.callCopyDis(disId, dialogRef.componentInstance.targetDisId);
      }
    });
  }

  renameDis(disId: string): void {
    console.log('rename ' + disId);
    const dialogRef = this.dialog.open(DialogRenameImageSetComponent, {
      data: {
        disId
      },
      width: '1000px',
      maxWidth: '100vw',
    });
    dialogRef.componentInstance.targetDisId = disId;
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result) {
        console.log(`Dialog targetDisId: ${dialogRef.componentInstance.targetDisId}`);
        this.callRenameDis(disId, dialogRef.componentInstance.targetDisId);
        // TODO refresh list
      }
    });
  }

  deleteDis(disId: string): void {
    console.log('delete ' + disId);
    const dialogRef = this.dialog.open(DialogDeleteImageSetComponent, {
      data: {
        disId
      },
      width: '1000px',
      maxWidth: '100vw',
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result) {
        this.callDeleteDis(disId);
        // TODO refresh list
      }
    });
  }

  callCopyDis(disId: string, targetDisId: string): void {
    this.apiService.copyDis(disId, targetDisId).subscribe(
      (success) => {
        this.notifierService.notify('info', 'Copy of ' + disId + ' started.');
      },
      (error) => {
        const errorMessage = ErrorHelper.disectError('Copy of  ' + disId + ' failed!', error);
        this.notifierService.notify('error', errorMessage);
      });
  }

  callRenameDis(disId: string, targetDisId: string): void {
    this.apiService.renameDis(disId, targetDisId).subscribe(
      (success) => {
        this.notifierService.notify('info', 'Rename of ' + disId + ' done.');
      },
      (error) => {
        const errorMessage = ErrorHelper.disectError('Rename of  ' + disId + ' failed!', error);
        this.notifierService.notify('error', errorMessage);
      });
  }

  callDeleteDis(disId: string): void {
    this.apiService.deleteDis(disId).subscribe(
      (success) => {
        this.notifierService.notify('info', 'Delete of ' + disId + ' started.');
      },
      (error) => {
        const errorMessage = ErrorHelper.disectError('CoDeletepy of  ' + disId + ' failed!', error);
        this.notifierService.notify('error', errorMessage);
      });
  }

}

@Component({
  selector: 'app-dialog-copy-image-set',
  templateUrl: 'dialog-copy-image-set.component.html',
})
export class DialogCopyImageSetComponent {
  targetDisId: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }
}

@Component({
  selector: 'app-dialog-rename-image-set',
  templateUrl: 'dialog-rename-image-set.component.html',
})
export class DialogRenameImageSetComponent {
  targetDisId: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }
}

@Component({
  selector: 'app-dialog-delete-image-set',
  templateUrl: 'dialog-delete-image-set.component.html',
})
export class DialogDeleteImageSetComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }
}

export interface DialogData {
  disId: string;
}
